import React, { useCallback, useState, useMemo } from "react"
import "./CategoryCard.css"
import { useDispatch, useSelector } from "react-redux"
import {
  SetSliderValue,
  SetUrlPrefix,
  SetImgPrefix,
  SetIsSearching,
  SetIsExpanded,
  SetSliderValueMinMax,
  SetPrevProducts,
  SetActiveFilters,
  SetProducts,
  SetAsyncData,
  SetListingBanner,
  SetResultsCount,
  SetFilters,
  SetMasterCategories,
  SetPages,
  SetPage,
  SetSuggestedWords,
} from "../../state/actions/index"
import Utils from "../../utils/Utils"
import axios from "axios"

const CategoryCard = (props) => {
  const searchWord = useSelector((state) => state.searchWord)
  const sort = useSelector((state) => state.sort)
  const products = useSelector((state) => state.products)
  const activeFilters = useSelector((state) => state.activeFilters)
  const configFilters = useSelector((state) => state.config.filters)
  const filters = useSelector((state) => state.filters)
  const card = useSelector((state) => state.config.card)
  const accentColor = useSelector((state) => state.config.accentColor)
  const config = useSelector((state) => state.config)
  const isMobile = useSelector((state) => state.isMobile)
  const defaultCategories = useSelector((state) => state.defaultCategories)
  const sliderValueMinMax = useSelector((state) => state.sliderValueMinMax)
  const sliderValue = useSelector((state) => state.sliderValue)
  const [hover, setHover] = useState(false)
  const dispatch = useDispatch()
  const { setSubCategory } = props
  var hoverStyle = useMemo(
    () => (hover ? { backgroundColor: accentColor } : null),
    [accentColor, hover]
  )

  const categoryKey = useMemo(() => {
    var valueToReturn = ""
    Object.keys(configFilters).forEach((filter) => {
      if (configFilters[filter].isCategory) valueToReturn = filter
    })
    return valueToReturn
  }, [configFilters])

  const categories = useMemo(() => {
    var categories = filters.filter((filter) => filter.title === categoryKey)
    return categories.length > 0 ? Object.keys(categories[0].values) : []
  }, [categoryKey, filters])

  const queryOptions = useSelector((state) => state.config.queryOptions)
  var rows = useMemo(
    () => (isMobile ? queryOptions.rows.mobile : queryOptions.rows.desktop),
    [isMobile, queryOptions]
  )

  const selectMasterCategory = useCallback(() => {
    var tempActiveFilters = activeFilters
    var valueToUse =
      props.value.value[props.value.value.length - 1] === "/"
        ? props.value.value.substring(0, props.value.value.length - 1)
        : props.value.value
    tempActiveFilters.push({
      key: categoryKey,
      value:
        valueToUse +
        (Utils.checkLastCategory(
          Object.keys(defaultCategories),
          valueToUse,
          true
        )
          ? ""
          : "*"),
    })
    dispatch(SetActiveFilters(tempActiveFilters))
    dispatch(SetIsSearching(true))
    dispatch(SetAsyncData([]))
    var priceGroup = {}
    priceGroup.id =
      window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
        ? window.AS_ADVANCED_CONFIG.visitorType
        : config.priceGroup.id
    priceGroup.currency =
      window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
        ? window.AS_ADVANCED_CONFIG.currencyCode
        : config.priceGroup.currency
    var localSearchUrl = Utils.getSearchUrl(
      config.baseUrl,
      config.queryOptions,
      priceGroup,
      config.shopId,
      config.jsonFast
    )
    axios
      .get(
        Utils.insertWordInSearchUrl(
          localSearchUrl,
          searchWord,
          tempActiveFilters,
          sort,
          1,
          configFilters,
          rows
        )
      )
      .then((res) => {
        var response = res.data
        dispatch(SetIsExpanded({}))
        dispatch(SetPrevProducts(products))
        dispatch(
          SetProducts(
            Utils.refactorUrl(
              response.data,
              response.header.imagePrefix,
              response.header.urlPrefix,
              card.img,
              card.url
            )
          )
        )
        dispatch(SetResultsCount(response.header.results_count))
        dispatch(
          SetSliderValueMinMax(
            Utils.addSliderValue(response, sliderValueMinMax)
          )
        )
        dispatch(SetSliderValue(Utils.addSliderValue(response, sliderValue)))
        dispatch(SetFilters(response))
        dispatch(SetSuggestedWords(response.suggestions))
        dispatch(
          SetPages(parseInt((response.header.results_count - 1) / rows) + 1)
        )
        dispatch(SetPage(1))
        dispatch(SetListingBanner(response.banners[0]))
        dispatch(SetMasterCategories([]))
        dispatch(SetUrlPrefix(response.header.urlPrefix))
        dispatch(SetImgPrefix(response.header.imagePrefix))
        if (config.webhook.key !== "")
          Utils.getAsyncData(config.webhook, response.data, priceGroup).then(
            (value) => dispatch(SetAsyncData(value.asyncData))
          )
        var websiteSearchBar = document.getElementById(
          "accelasearch-bar-container-container"
        )
        const event = new CustomEvent("as-search-event", {
          detail: {
            searchWord: searchWord,
            filters: tempActiveFilters,
            page: 1,
          },
        })
        websiteSearchBar.dispatchEvent(event)
      })
      .finally(() => dispatch(SetIsSearching(false)))
  }, [
    dispatch,
    props,
    searchWord,
    activeFilters,
    sort,
    rows,
    sliderValueMinMax,
    sliderValue,
    config,
    configFilters,
    defaultCategories,
    products,
    categoryKey,
    card,
  ])

  const selectCategory = useCallback(() => {
    setSubCategory({
      key: null,
      value: undefined,
      parent: "",
      parentChildren: [],
      level: 1,
    })
    var tempActiveFilters = activeFilters
    var valueToUse =
      props.value.value[props.value.value.length - 1] === "/"
        ? props.value.value.substring(0, props.value.value.length - 1)
        : props.value.value
    tempActiveFilters.push({
      key: categoryKey,
      value:
        valueToUse +
        (Utils.checkLastCategory(categories, valueToUse, true) ? "" : "/*"),
    })
    dispatch(SetActiveFilters(tempActiveFilters))
    dispatch(SetIsSearching(true))
    dispatch(SetAsyncData([]))
    var priceGroup = {}
    priceGroup.id =
      window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
        ? window.AS_ADVANCED_CONFIG.visitorType
        : config.priceGroup.id
    priceGroup.currency =
      window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
        ? window.AS_ADVANCED_CONFIG.currencyCode
        : config.priceGroup.currency
    var localSearchUrl = Utils.getSearchUrl(
      config.baseUrl,
      config.queryOptions,
      priceGroup,
      config.shopId,
      config.jsonFast
    )
    axios
      .get(
        Utils.insertWordInSearchUrl(
          localSearchUrl,
          searchWord,
          tempActiveFilters,
          sort,
          1,
          configFilters,
          rows
        )
      )
      .then((res) => {
        var response = res.data
        dispatch(SetIsExpanded({}))
        dispatch(SetPrevProducts(products))
        dispatch(
          SetProducts(
            Utils.refactorUrl(
              response.data,
              response.header.imagePrefix,
              response.header.urlPrefix,
              card.img,
              card.url
            )
          )
        )
        dispatch(SetResultsCount(response.header.results_count))
        dispatch(
          SetSliderValueMinMax(
            Utils.addSliderValue(response, sliderValueMinMax)
          )
        )
        dispatch(SetSliderValue(Utils.addSliderValue(response, sliderValue)))
        dispatch(SetFilters(response))
        dispatch(SetSuggestedWords(response.suggestions))
        dispatch(
          SetPages(parseInt((response.header.results_count - 1) / rows) + 1)
        )
        dispatch(SetPage(1))
        dispatch(SetListingBanner(response.banners[0]))
        dispatch(SetMasterCategories([]))
        dispatch(SetUrlPrefix(response.header.urlPrefix))
        dispatch(SetImgPrefix(response.header.imagePrefix))
        if (config.webhook.key !== "")
          Utils.getAsyncData(config.webhook, response.data, priceGroup).then(
            (value) => dispatch(SetAsyncData(value.asyncData))
          )
        var websiteSearchBar = document.getElementById(
          "accelasearch-bar-container-container"
        )
        const event = new CustomEvent("as-search-event", {
          detail: {
            searchWord: searchWord,
            filters: tempActiveFilters,
            page: 1,
          },
        })
        websiteSearchBar.dispatchEvent(event)
      })
      .finally(() => dispatch(SetIsSearching(false)))
  }, [
    dispatch,
    props,
    searchWord,
    activeFilters,
    sort,
    rows,
    sliderValueMinMax,
    sliderValue,
    config,
    configFilters,
    categories,
    products,
    categoryKey,
    card,
  ])
  return props.isShowcaseTile ? (
    <div
      className={"category-card " + Utils.returnLastCategory(props.value.value)}
      style={{ backgroundImage: "url(" + props.value.img + ")" }}
    >
      <div
        className="color-bg"
        onClick={selectMasterCategory}
        style={hoverStyle}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {" "}
        {props.value.name}{" "}
      </div>
    </div>
  ) : (
    <div
      className={"category-card " + Utils.returnLastCategory(props.value.value)}
    >
      <div
        className="color-bg"
        onClick={selectCategory}
        style={hoverStyle}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {" "}
        {Utils.returnLastCategory(props.value.value)}{" "}
      </div>
    </div>
  )
}

export default CategoryCard
